import React, { useState } from "react";
import PropTypes from "prop-types";
import RevShareModal from "../../common/overrides/RevShareModal";
import DatePicker from "../../common/forms/DatePicker";

const EditPaidDateModal = ({ request, edit }) => {
  const [date, setDate] = useState(request.datePaid);

  return (
    <RevShareModal buttonText="Edit Paid Date" title="Edit Paid Date" yesButtonOnClick={() => edit(date)}>
      <DatePicker
        label="Date Paid"
        value={request.datePaid}
        onChange={(event) => {
          setDate(event.target.value);
        }}
      />
    </RevShareModal>
  );
};

EditPaidDateModal.propTypes = {
  edit: PropTypes.func.isRequired,
  request: PropTypes.object.isRequired,
};

export default EditPaidDateModal;
